export const MARGINS = {
  DEFAULT: 'Default',
  SMALL: 'Small',
} as const
